// import jQuery from 'CommonScripts/jquery-1.10.2';
import Hammer from 'hammerjs';

(function (window, document, $) {

    $(document).ready(function () {
        /* Create BeforeAfter object with all settings */
        var $root = document.querySelectorAll('main .before-after');
        if ($root.length > 0) {
            $root = $($root);
            var BeforeAfter = {
                    dom: {
                        base: $root,
                        beforeImg: $root.find('.before-after__bottom-area__image-before .before-after-img'),
                        AfterImg: $root.find('.before-after__bottom-area__image-after .before-after-img'),
                        before: $root.find('.before-after__bottom-area__image-before'),
                        after: $root.find('.before-after__bottom-area__image-after'),
                        titleContainer: $root.find('.before-after__title-container'),
                        titleAfter: $root.find('.before-after__title-container h2'),
                        titleBefore: $root.find('.before-after__bottom-area__image-before h2')
                    },
                    set: {
                        initialGalleryWidth: $root.width(),
                        windowWith: $(window).width(),
                        gtmData: $root[0].dataset.jsGtmData
                    },
                    fn: {
                        init: function () {
                            //$fn.getBackgroundImageSize();
                        },
                        getBackgroundImageSize: function (el) {
                            var imageUrl = $(el).css('background-image').match(/^url\(["']?(.+?)["']?\)$/);
                            var dfd = new $.Deferred();

                            if (imageUrl) {
                                var image = new Image();
                                image.onload = dfd.resolve;
                                image.onerror = dfd.reject;
                                image.src = imageUrl[1];
                            } else {
                                dfd.reject();
                            }
                            return dfd.then(function () {

                                return {
                                    width: this.width,
                                    height: this.height
                                };
                            });
                        },

                        registerPan: function () {
                            var mc = document.querySelector('main .before-after');
                            var $hammer = new Hammer(mc);
                            
                            $hammer.on(
                                'panleft',
                                function (ev) {
                                    $fn.onBtnDrag(ev);
                                });
                            $hammer.on(
                                'panright',
                                function (ev) {
                                    $fn.onBtnDrag(ev);
                                });
                            $hammer.on(
                                'panend',
                                function (ev) {
                                    $fn.onDragEnd(ev);
                                });
                        },

                        onBtnDrag: function (e) {
                            $fn.setImageWidth(e);
                        },

                        setImageWidth: function (e) {
                            const element = $dom.after;
                            const titleCont = $dom.titleContainer;
                            let pos = e.center.x;
                            const actualDeviceWidth = $fn.getGalleryWidth();

                            if ($set.windowWith > $set.initialGalleryWidth) {
                                let offset = ($fn.getWindowWidth() - actualDeviceWidth) / 2;
                                pos -= offset;
                            }
                            const newPos = Math.round((pos / actualDeviceWidth) * 100);

                            if (newPos > 0 && newPos < 100) {
                                element[0].style.width = newPos + '%';
                                titleCont[0].style.width = newPos + '%';
                            }
                        },
                        getGalleryWidth: function () {
                            return $dom.base.width();
                        },
                        getGalleryHeight: function () {
                            return $dom.base.height();
                        },
                        getWindowWidth: function () {
                            return $(window).width();
                        },
                        // Fix for mobile view
                        fixAspectRatio(windowWidth, imgWidth, imgHeight) {
                            var newHeight = (imgHeight * windowWidth) / imgWidth;
                            return newHeight;
                        },

                        onDragEnd: function () {
                            if ($set.gtmData) {
                                const {
                                    event,
                                    eventaction,
                                    eventcategory,
                                    eventlabel
                                } = JSON.parse($set.gtmData);

                                dataLayer.push({
                                    event,
                                    eventaction,
                                    eventcategory,
                                    eventlabel
                                });
                            }
                        },
                        parsePaddingToInt: function (parsedPadding) {
                            return parseInt(parsedPadding, 10);
                        },

                        calculateTitleWidth: function (title) {
                            var titlePaddingLeft = title.css('padding-left');
                            var titlePaddingRight = title.css('padding-right').replace(/[^-\d\.]/g, '');
                            var titleWidth = ($set.initialGalleryWidth - $fn.parsePaddingToInt(titlePaddingLeft)) - titlePaddingRight;
                            return titleWidth;
                        },

                        calculateImgBackground: function () {
                            $fn.getBackgroundImageSize($dom.beforeImg)
                                .then(function (size) {
                                    // check if the window is smaller than the height of the image and adjust the height.
                                    if ($dom.titleAfter.length > 0) {
                                        $dom.titleAfter.css('width', $fn.calculateTitleWidth($dom.titleAfter));
                                    }

                                    if ($dom.titleBefore.length > 0) {
                                        $dom.titleBefore.css('width', $fn.calculateTitleWidth($dom.titleBefore));
                                    }

                                    if ($set.windowWith < size.width) {
                                        var newHeight = $fn.fixAspectRatio($set.windowWith, size.width, size.height);
                                        $dom.base.css('height', newHeight);

                                    } else {
                                        $dom.base.css('height', size.height);
                                    }

                                })
                                .fail(function () {
                                    console.log('Could not set size because could not load image');
                                })
                        }

                    }

                },
                $dom = BeforeAfter.dom,
                $set = BeforeAfter.set,
                $fn = BeforeAfter.fn;

            $fn.calculateImgBackground();
            $fn.registerPan();
            $(window).on('resize', function () {
                $set.initialGalleryWidth = $dom.base.width();
                $set.windowWith = $(window).width();
                $fn.calculateImgBackground();
            });
        }
    });

})(window, document, jQuery);